// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"7e4eb52d","984":"332ca6f3"}[chunkId] + ".chunk.js";
};